import SitesList from './SitesList';

export default SitesList;
